/**
 * date-fns does not currently provide the convenient zone names for
 * the zone offsets we support, so we'll borrow from the Intl API.
 * @example 'PDT', 'PST', 'EST'
 */
export const timezoneToken = (timeZone: string) => {
  return Intl.DateTimeFormat('en-US', {
    timeZone,
    timeZoneName: 'short',
  })
    .format(new Date())
    .split(', ')[1];
};
